<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="My Devices" pageTitle="Recent" />
            <RecentDevices />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import RecentDevices from '../Recent/RecentDevices'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'RecentPage',
    components: {
        MainHeader,
        PageTitle,
        RecentDevices,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>